import React from "react";
import { Link } from "react-router-dom";

function EmptyPage() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-1 gap-5 lg:gap-10 py-12 lg:py-32 lg:px-20 ">
      <div className="flex justify-center items-center content-center">
        <img
          src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_empty.svg"}
          alt="icon-empty"
          className="w-4/5 lg:w-3/5"
        />
      </div>
      <div className="flex justify-center items-center content-center">
        <div>
          <p className="header-title-bold text-9xl font-bold text-center tracking-wide colors-blue">
            4 0 4
          </p>
          <p className="header-content text-4xl font-semibold text-center tracking-wider text-black">
            Page Not Found
          </p>
          <div className="flex justify-center ">
            <p className="header-content w-3/4 lg:w-2/3 my-10 colors-gray text-center text-base">
              Mohon maaf halaman yang anda cari tidak ditemukan Anda dapat
              kembali ke homepage
            </p>
          </div>
          <Link to="/">
            <div className="w-full flex justify-center">
              <button className="btn-blue lg:mx-0 mx-5 w-full lg:w-2/5 p-3  focus:outline-none">
                <div className="text-white lg:text-lg">Homepage</div>
              </button>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default EmptyPage;
